/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeDate } from './TimeDate';
import {
    TimeDateFromJSON,
    TimeDateFromJSONTyped,
    TimeDateToJSON,
    TimeDateToJSONTyped,
} from './TimeDate';

/**
 * 
 * @export
 * @interface UpdateCaseNoteFromDocumentRequest
 */
export interface UpdateCaseNoteFromDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCaseNoteFromDocumentRequest
     */
    fileName: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCaseNoteFromDocumentRequest
     */
    date: Date | null;
    /**
     * 
     * @type {TimeDate}
     * @memberof UpdateCaseNoteFromDocumentRequest
     */
    time: TimeDate | null;
}

/**
 * Check if a given object implements the UpdateCaseNoteFromDocumentRequest interface.
 */
export function instanceOfUpdateCaseNoteFromDocumentRequest(value: object): value is UpdateCaseNoteFromDocumentRequest {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    return true;
}

export function UpdateCaseNoteFromDocumentRequestFromJSON(json: any): UpdateCaseNoteFromDocumentRequest {
    return UpdateCaseNoteFromDocumentRequestFromJSONTyped(json, false);
}

export function UpdateCaseNoteFromDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCaseNoteFromDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'date': (json['date'] == null ? null : new Date(json['date'])),
        'time': TimeDateFromJSON(json['time']),
    };
}

export function UpdateCaseNoteFromDocumentRequestToJSON(json: any): UpdateCaseNoteFromDocumentRequest {
    return UpdateCaseNoteFromDocumentRequestToJSONTyped(json, false);
}

export function UpdateCaseNoteFromDocumentRequestToJSONTyped(value?: UpdateCaseNoteFromDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'date': value['date'] == null ? value['date'] : `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'time': TimeDateToJSON(value['time']),
    };
}

